export default class extends Controller {
  static targets = ["title"]

  connect() {
    this.replaceTitleWith = this.replaceTitleWith.bind(this)
    App.Helpers.listenToCustomEvent(document, "primary-content-pane-load:success", this.replaceTitleWith)
  }

  replaceTitleWith({ detail }) {
    const { contentTitle } = detail
    this.titleTarget.innerHTML = this.titleFor(contentTitle)
  }

  titleFor(setting) {
    return this.data.get(`${setting}-title`)
  }
}



// WEBPACK FOOTER //
// ./app/components/my_via/assets/javascript/my-via-index-heading-controller.js